import { g as getAugmentedNamespace } from './_commonjsHelpers-357b3b4e.js';
import { t as tslib_es6 } from './tslib.es6-8b55ad02.js';

var require$$0 = /*@__PURE__*/getAugmentedNamespace(tslib_es6);

export { require$$0 as r };
//# sourceMappingURL=tslib.es6-fb850d3c.js.map
